import { IChecklistTemplate } from 'APIPackage/AccountModule/interfaces/IChecklistTemplate';

import { IChecklistTemplateSelectOption } from '../interfaces/IChecklistTemplateSelectOption';

export function createChecklistTemplateSelectOption(
  checklistTemplate: IChecklistTemplate,
): IChecklistTemplateSelectOption {
  return {
    ...checklistTemplate,
    label: checklistTemplate.name,
    value: checklistTemplate.id,
  };
}
